module.exports = __webpack_public_path__ + "static/WEDDING E&M-51-44ee7f4fd9b931a279bfe2dfff2a709c.jpg";